import dasboardReducer from './dashboard/dasboardReducer';
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import authReducer from "./auth/authReducer";
import filterReducer from "./filter/filterReducer";
import webCallReducer from './webcall/webCallReducer';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        filter: filterReducer,
        dashboard: dasboardReducer,
        webcall: webCallReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch